import { createSelector } from '@ngrx/store';
import { onlineOrderState } from '../root';

export const orderIsValidForPostingOnlineOrder = createSelector(
    onlineOrderState,
    (onlineOrder) => onlineOrder.createRequest.hasSucceeded === false && onlineOrder.recalculateRequest.hasSucceeded === true && onlineOrder.recalculateRequest.data !== null,
);
